<template>
    <div class="publication__success content-width">

        <div class="publication__success-block">

            <div class="publication__success-content d-flex">
                <div class="publication__success-title">
                    {{$store.getters.t('facilities_publication_success')}}
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: "PublicationSuccess",
    props: ['server']
}
</script>

<style scoped>

</style>
